// extracted by mini-css-extract-plugin
export var aboutHeroImage = "about-module--about-hero-image--lBAs_";